import type { IconData } from '@stacksjs/iconify-core'

export const filterPhoto: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M440 40H72a32.036 32.036 0 0 0-32 32v368a32.036 32.036 0 0 0 32 32h368a32.036 32.036 0 0 0 32-32V72a32.036 32.036 0 0 0-32-32m0 400H72V72h368Z\"/><path fill=\"currentColor\" d=\"m120.614 261.739l.031 2.261l.317 22.978l21.874 7.041l60.183 19.373l18.781 59.642l7.051 22.387h54.3l7.051-22.387l18.782-59.642l60.183-19.373l21.874-7.041l.314-22.978l.031-2.261l.071-5.092l.322-23.282l-22.053-7.465l-56.47-19.127l-23.3-68.995l-7.348-21.763h-53.22l-7.348 21.763l-23.3 69l-56.466 19.122l-22.053 7.469l.322 23.282ZM224 232l28.359-83.989h7.282L288 232l71.46 24.2c-.049 3.519-.053 3.836-.1 7.354L283.428 288l-23.751 75.421h-7.354L228.572 288l-75.93-24.442c-.049-3.518-.053-3.835-.1-7.354Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default filterPhoto
